<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
        <i class="fal fa-times-circle fa-lg"></i>
      </span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a
            class="nav-link m-tabs__link active"
            data-toggle="tab"
            href="#save_contract"
            role="tab"
          >
            <h5><span class="far fa-pen-nib"></span> Importar Planilha</h5>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="save_contract" role="tabpanel">
          <form name="contract" class="needs-validation" novalidate>
            <div class="row mt-3">
              <div class="col-md-12">
                <label for="note">Arquivo</label>
                <div class="input-group">
                  <input
                    accept=".csv"
                    type="file"
                    class="form-control"
                    name="file"
                    ref="fileInput"
                    @change="chooseFile"
                  />
                </div>
              </div>
            </div>

            <hr class="row mt-5 mb-3" />

            <div class="row mb-5">
              <div class="col-md-12 text-right">
                <button
                  type="button"
                  @click.prevent="download($event)"
                  class="btn mr-2"
                  :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
                  :disabled="!formIsValid || loading"
                >
                  <i class="fas fa-solid fa-download"></i>
                  Baixar Modelo
                </button>
                <button
                  @click.prevent="saveForm()"
                  class="btn"
                  :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
                  :disabled="!formIsValid || loading"
                >
                  <i class="fas fa-save" v-if="formIsValid"></i>
                  <i class="fas fa-exclamation-triangle" v-else></i>
                  Salvar
                </button>
              </div>
              <div class="col-md-6 text-right"></div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { baseApiUrl } from '@/global';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  name: 'InvoiceGenerateCsv',
  data() {
    return {
      data: {},
      alert: null,
      file: {
        selected: false,
      },
    };
  },
  components: {},
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showContractSave = null;
    },
    download() {
      this.downloading = true;
      const url = `${baseApiUrl}/v1/invoice/download-model`;

      axios(url)
        .then((res) => {
          debugger;
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [Object.keys(arrData[0]).join('\n'), null]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');

          link.setAttribute('href', data);

          let fileName = `modelo`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);

          link.click();
          this.downloading = false;
        })
        .catch((error) => {
          console.log(error);
          this.downloading = false;
        });
    },
    saveForm() {
      this.messageWaitingSave();

      const e = this.file.selected;
      const { files } = e.target;
      const file = files[0];

      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', this.data.name);
      formData.append('contract_id', this.contractId);
      formData.append('pathFile', `contracts/${this.$store.state.showContractSave}`);

      const urlForm = `${baseApiUrl}/v1/invoice/upload`;
      axios
        .post(urlForm, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          this.reset();
          this.logMessageForm(res);
          this.callData();
        })
        .catch((error) => this.logMessageFormFailed(error));
    },
    chooseFile(e) {
      this.file.selected = e;
      this.data.file = e;
    },
  },
  computed: {
    formIsValid() {
      return true;
    },
  },
};
</script>
<style>
.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
